import { render, staticRenderFns } from "./folder-tree.vue?vue&type=template&id=5db467ea&scoped=true"
import script from "./folder-tree.vue?vue&type=script&lang=js"
export * from "./folder-tree.vue?vue&type=script&lang=js"
import style0 from "./folder-tree.vue?vue&type=style&index=0&id=5db467ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db467ea",
  null
  
)

export default component.exports